import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ButtonComponent } from "../button/button.component";
import { MatRipple } from "@angular/material/core";
import { ManagedModalDirective } from "../managed-modal/managed-modal.directive";

@Component({
    selector: "app-confirm-dialog",
    templateUrl: "./confirm-dialog.component.html",
    styleUrls: ["./confirm-dialog.component.scss"],
    standalone: true,
    imports: [
        ManagedModalDirective,
        MatRipple,
        ButtonComponent,
    ],
})
export class ConfirmDialogComponent {
  @Input() dialogTitle: string;
  @Input() dialogSubtitle: string;
  @Input() visible: boolean;
  @Output() answered = new EventEmitter<boolean>();

  constructor() {}

  onYesClicked() {
    this.answered.emit(true);
  }

  onNoClicked() {
    this.answered.emit(false);
  }
}
